const mediaItems = [
  {
    id: 1,
    title: '星际迷航：新纪元',
    tag: '科幻巨制',
    desc: '视觉特效全面升级，探索未知宇宙的壮丽旅程，年度最受期待科幻大片',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20spaceship%20flying%20through%20colorful%20nebula%20clouds%2C%20dramatic%20space%20landscape%20with%20distant%20planets%2C%20futuristic%20visual%20effects%2C%20deep%20blue%20and%20purple%20cosmic%20colors%2C%20epic%20scale%2C%20film%20grain%20texture%2C%20cinematic%20lighting%2C%20widescreen%20composition&width=640&height=360&seq=media-sci-fi&orientation=landscape',
  },
  {
    id: 2,
    title: '长安十二时辰',
    tag: '古装悬疑',
    desc: '盛世大唐风云诡谲，十二时辰生死追击，口碑爆棚年度历史悬疑力作',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20night%20with%20red%20lanterns%2C%20traditional%20architecture%2C%20misty%20atmosphere%2C%20dramatic%20moonlight%2C%20period%20drama%20cinematic%20style%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20mysterious%20noir%20lighting%2C%20film%20quality&width=640&height=360&seq=media-period&orientation=landscape',
  },
  {
    id: 3,
    title: '流浪地球3',
    tag: '国产科幻',
    desc: '中国科幻电影巅峰系列最新章，人类命运共同体史诗级太空冒险',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20landscape%20with%20massive%20planet%20engines%20glowing%20blue%20on%20frozen%20earth%20surface%2C%20dramatic%20ice%20and%20fire%20contrast%2C%20colossal%20scale%2C%20cinematic%20atmosphere%2C%20human%20figures%20small%20in%20frame%2C%20orange%20and%20blue%20dramatic%20lighting%2C%20film%20poster%20quality%2C%20epic%20composition&width=640&height=360&seq=media-wandering&orientation=landscape',
  },
  {
    id: 4,
    title: '浪姐·巅峰对决',
    tag: '热门综艺',
    desc: '实力姐姐终极舞台对决，全程高能名场面不断，今夏最燃综艺盛宴',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20performance%20with%20colorful%20concert%20lighting%2C%20spotlight%20beams%2C%20energetic%20atmosphere%2C%20musical%20show%20production%2C%20dynamic%20stage%20design%2C%20glowing%20neon%20accents%2C%20entertainment%20show%20vibe%2C%20professional%20stage%20photography%20style&width=640&height=360&seq=media-stage&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wide mb-3">
            最新上线
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            精彩推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            每日精选热门影视内容，为您推荐最值得观看的佳作
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="inline-block px-2 py-0.5 rounded bg-primary-500/90 text-white text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center rounded-full bg-black/40 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-lg"></i>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}